import axios from "axios";
import { Metadados } from "../classes/Metadados";

async function getUserOpti() {
    return await axios.get(`/wp-admin/admin-ajax.php?action=get_data_user`)
        .then(res => res.data.data)
}

export function getEstrutura(state) {
    const { estrutura } = state;
    return estrutura;
}
export function getArtigo(state) {
    const { artigo } = state;
    return artigo;
}
export function getAnalise(state, analise) {
    const { analises } = state;
    return analises.get(analise);
}
export function getStatusAnalise(state, analise) {
    const { analises } = state;
    return analises.get(analise)?.updating;
}
export function getStatusEstrutura(state) {
    const { updatingEstrutura } = state;
    return updatingEstrutura;
}
export function getStatusSEO(state) {
    const { updatingSEO } = state;
    return updatingSEO;
}
export function getTodasAnalise(state) {
    const { analises } = state;
    return analises;
}
export function getAnaliseSeo(state) {
    const { analiseSeo } = state;
    return analiseSeo;
}
export function getTokenOpti(state) {
    const { optiToken } = state;
    return optiToken;
}
export function getBlogIdOpti(state) {
    const { blogIdOpti } = state;
    return blogIdOpti;
}
export function getUsuarioIdOpti(state) {
    const { usuarioIdOpti } = state;
    return usuarioIdOpti;
}
export function getResultSeo(state) {
    const { resultSeo } = state;
    return resultSeo;
}
export function getKeyword(state) {
    const { keyword } = state;
    return keyword;
}
export function obterMetaDados(state) {
    const { meta } = state;
    return new Metadados({...meta});
}

export function obterMetaDadosSemObjeto(state) {
    const { meta } = state;
    return meta;
}

export const getUserLoggedIn = (state) => state.userLoggedIn;